import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useTenantConfig } from '../context/TenantConfigContext'
import DynamicHero from '../components/heroes'
import VehicleCard from '../components/VehicleCard'
import HomeTestimonials from '../components/home/HomeTestimonials'
import './HomePage.css'

function HomePage() {
  const { t } = useTranslation()
  const { vehicles } = useTenantConfig()
  const featured = vehicles.slice(0, 4)

  return (
    <div className="home">
      <DynamicHero />

      {featured.length > 0 ? (
        <section className="home-featured" id="home-featured" aria-labelledby="home-featured-title">
          <div className="home-featured__inner">
            <div className="home-featured__head">
              <div>
                <span className="home-featured__eyebrow">{t('home.featured.eyebrow')}</span>
                <h2 id="home-featured-title" className="home-featured__title">
                  {t('home.featured.title')}
                </h2>
                <p className="home-featured__sub">{t('home.featured.subtitle')}</p>
              </div>
              <Link to="/vehiculos" className="home-featured__link">
                {t('home.featured.viewAll')}
                <span aria-hidden>→</span>
              </Link>
            </div>
            <div className="home-featured__grid">
              {featured.map((v) => (
                <VehicleCard key={v.id} vehicle={v} variant="modern" />
              ))}
            </div>
          </div>
        </section>
      ) : null}

      <HomeTestimonials />
    </div>
  )
}

export default HomePage
